let a_atoms = ["N1", "C2", "N3", "C4", "C5", "C6", "N7", "C8", "N9"];
let g_atoms = ["N1", "C2", "N3", "C4", "C5", "C6", "N7", "C8", "N9"];
let u_atoms = ["N1", "C2", "N3", "C4", "C5", "C6"];
let c_atoms = ["N1", "C2", "N3", "C4", "C5", "C6"];
let psu_atoms = ["N1", "C2", "N3", "C4", "C5", "C6"];
let da_atoms = ["N1", "C2", "N3", "C4", "C5", "C6", "N7", "C8", "N9"];
let dg_atoms = ["N1", "C2", "N3", "C4", "C5", "C6", "N7", "C8", "N9"];
let dc_atoms = ["N1", "C2", "N3", "C4", "C5", "C6"];
let dt_atoms = ["N1", "C2", "N3", "C4", "C5", "C6"];
let trp_atoms = ["CG", "CD1", "NE1", "CE2", "CD2", "CE3", "CZ3", "CZ2", "CH2"];
let tyro_atoms = ["CG", "CD1", "CE1", "CZ", "CD2", "CE2"];
let his_atoms = ["ND1", "CG", "CE1", "NE2", "CD2"];
let phe_atoms = ["CG", "CD1", "CD2", "CE1", "CE2", "CZ"];


export const RING_ATOMS = {
    "A": a_atoms,
    "G": g_atoms,
    "U": u_atoms,
    "C": c_atoms,
    "PSU": psu_atoms,
    "DG": dg_atoms,
    "DA": da_atoms,
    "DC": dc_atoms,
    "DT": dt_atoms,
    "TYR": tyro_atoms,
    "ATYR": tyro_atoms,
    "BTYR": tyro_atoms,
    "TRP": trp_atoms,
    "ATRP": trp_atoms,
    "BTRP": trp_atoms,
    "HIS": his_atoms,
    "AHIS": his_atoms,
    "BHIS": his_atoms,
    "PHE": phe_atoms,
    "APHE": phe_atoms,
    "BPHE": phe_atoms,
    "8AN": a_atoms,
    "1MA": a_atoms,
    "AMP": a_atoms,
    "MTA": a_atoms,
    "A2M": a_atoms,
    "N6G": a_atoms,
    "2IA": a_atoms,
    "0A": a_atoms,
    "DTP": a_atoms,
    "A7C": a_atoms,
    "A44/": a_atoms,
    "SAH": a_atoms,
    "APC": a_atoms,
    "2MA": a_atoms,
    "7AT": a_atoms,
    "45A": a_atoms,
    "ZAD": a_atoms,
    "MIA": a_atoms,
    "PPU": a_atoms,
    "1DP": a_atoms,
    "A6A": a_atoms,
    "12A": a_atoms,
    "4M2/": a_atoms,
    "EEM": a_atoms,
    "CVC": a_atoms,
    "RIA": a_atoms,
    "QSQ": a_atoms,
    "F7O": a_atoms,
    "6MA": a_atoms,
    "A23/": a_atoms,
    "XAR": a_atoms,
    "6MZ": a_atoms,
    "LCA": a_atoms,
    "6HA": a_atoms,
    "31M": a_atoms,
    "3DA": a_atoms,
    "ATP": a_atoms,
    "AF2/": a_atoms,
    "F3N": a_atoms,
    "F6U": a_atoms,
    "A7E": a_atoms,
    "6MD": a_atoms,
    "AT7/": a_atoms,
    "PU": a_atoms,
    "6IA": a_atoms,
    "T6A": a_atoms,
    "P5P": a_atoms,
    "MA6/": a_atoms,
    "31H": a_atoms,
    "2BA": a_atoms,
    "ADN": a_atoms,
    "2AD": a_atoms,
    "AVC": a_atoms,
    "5AA": a_atoms,
    "M7A": a_atoms,
    "4BW": a_atoms,
    "SAM": a_atoms,
    "APN": a_atoms,
    "E7X": a_atoms,
    "ADS": a_atoms,
    "DSH": a_atoms,
    "Y5P": u_atoms,
    "UR3/": u_atoms,
    "UMO": u_atoms,
    "H2U": u_atoms,
    "A6U": u_atoms,
    "5IU": u_atoms,
    "UFB": u_atoms,
    "IU": u_atoms,
    "P4U": u_atoms,
    "2MU": u_atoms,
    "U4M": u_atoms,
    "U36/": u_atoms,
    "UOA": u_atoms,
    "HYG": u_atoms,
    "U33/": u_atoms,
    "0U": u_atoms,
    "2AU": u_atoms,
    "4SU": u_atoms,
    "UFT": u_atoms,
    "UTP": u_atoms,
    "OMU": u_atoms,
    "DOL": u_atoms,
    "6FU": u_atoms,
    "J48/": u_atoms,
    "URU": u_atoms,
    "5FU": u_atoms,
    "RUS": u_atoms,
    "H2U20^A": u_atoms,
    "UZR": u_atoms,
    "0U1/": u_atoms,
    "5BU": u_atoms,
    "UOB": u_atoms,
    "SSU": u_atoms,
    "BRU": u_atoms,
    "SUR": u_atoms,
    "UMS": u_atoms,
    "I4U": u_atoms,
    "U5M": u_atoms,
    "US5/": u_atoms,
    "U23/": u_atoms,
    "T5S": u_atoms,
    "U5R": u_atoms,
    "ZBU": u_atoms,
    "2KH": u_atoms,
    "C2E": g_atoms,
    "P7G": g_atoms,
    "DGP": g_atoms,
    "GDO": g_atoms,
    "B8W": g_atoms,
    "XUG": g_atoms,
    "PGN": g_atoms,
    "5GP": g_atoms,
    "ZGU": g_atoms,
    "M2G": g_atoms,
    "F73/": g_atoms,
    "HPA": g_atoms,
    "MHG": g_atoms,
    "GT3/": g_atoms,
    "B8K": g_atoms,
    "LCG": g_atoms,
    "G2P": g_atoms,
    "GRB": g_atoms,
    "GUN": g_atoms,
    "Q61/": g_atoms,
    "OMG": g_atoms,
    "E6G": g_atoms,
    "GNG": g_atoms,
    "5CG": g_atoms,
    "2MG": g_atoms,
    "QUO": g_atoms,
    "I": g_atoms,
    "7MG": g_atoms,
    "GMP": g_atoms,
    "PRF": g_atoms,
    "GNP": g_atoms,
    "G48/": g_atoms,
    "1MG": g_atoms,
    "B9B": g_atoms,
    "XGR": g_atoms,
    "GMX": g_atoms,
    "G4P": g_atoms,
    "F7U": g_atoms,
    "PGP": g_atoms,
    "0G": g_atoms,
    "G46/": g_atoms,
    "GDP": g_atoms,
    "23G": g_atoms,
    "BGM": g_atoms,
    "GPN": g_atoms,
    "Q1V": g_atoms,
    "G7M": g_atoms,
    "6HG": g_atoms,
    "MTU": g_atoms,
    "TG": g_atoms,
    "BGH": g_atoms,
    "SDG": g_atoms,
    "G5J": g_atoms,
    "GTP": g_atoms,
    "F7X": g_atoms,
    "E7G": g_atoms,
    "G47/": g_atoms,
    "2SG": g_atoms,
    "GF2/": g_atoms,
    "A6G": g_atoms,
    "1SC": c_atoms,
    "BLS": c_atoms,
    "5CF": c_atoms,
    "CTP": c_atoms,
    "AG9/": c_atoms,
    "1CC": c_atoms,
    "A6C": c_atoms,
    "N5M": c_atoms,
    "E3C": c_atoms,
    "S4C": c_atoms,
    "ZCY": c_atoms,
    "CFL": c_atoms,
    "CCC": c_atoms,
    "6HC": c_atoms,
    "OMC": c_atoms,
    "B9H": c_atoms,
    "O2C": c_atoms,
    "CFZ": c_atoms,
    "6FC": c_atoms,
    "B8Q": c_atoms,
    "5HM": c_atoms,
    "XCR": c_atoms,
    "DCZ": c_atoms,
    "C43/": c_atoms,
    "F6X": c_atoms,
    "CBV": c_atoms,
    "B8T": c_atoms,
    "QSK": c_atoms,
    "NCU": c_atoms,
    "LCC": c_atoms,
    "A5M": c_atoms,
    "5MC": c_atoms,
    "F7R": c_atoms,
    "LHH": c_atoms,
    "CBR": c_atoms,
    "N5C": c_atoms,
    "CPN": c_atoms,
    "M5M": c_atoms,
    "LV2/": c_atoms,
    "CSL": c_atoms,
    "0C": c_atoms,
    "JMH": c_atoms,
    "5CM": c_atoms,
    "73W": c_atoms,
    "5IC": c_atoms,
    "RSP": c_atoms,
    "DCT": c_atoms,
    "RSQ": c_atoms,
    "DOC": c_atoms,
    "4AC": c_atoms,
    "4OC": c_atoms,
    "70U": u_atoms,
    "T2T": u_atoms,
    "CM0/": u_atoms,
    "5MU": u_atoms,
    "US3/": u_atoms,
    "TM2/": u_atoms,
    "TPN": u_atoms,
    "ZTH": u_atoms,
    "2QB": u_atoms,
    "XTR": u_atoms,
    "75B": u_atoms,
    "6HT": u_atoms,
    "6F7/": u_atoms,
    "MNU": u_atoms,
    "U8U": u_atoms,
    "TLN": u_atoms,
    "NTT": u_atoms,
    "8RJ": u_atoms,
}